import '../assets/styles/layout.scss';
import { ReactComponent as PlaygroundIcon } from '../assets/icons/menu/playground-nav.svg';
import { ReactComponent as BenefitsIcon } from '../assets/icons/menu/benefits-nav.svg';
import { ReactComponent as YaongconIcon } from '../assets/icons/menu/yaongcon-nav.svg';
import { ReactComponent as YaongeggIcon } from '../assets/icons/menu/yaongegg-nav.svg';
import { ReactComponent as MyIcon } from '../assets/icons/menu/my-nav.svg';
import { ReactComponent as PlaygroundSelectedIcon } from '../assets/icons/menu/playground-nav-selected.svg';
import { ReactComponent as BenefitsSelectedIcon } from '../assets/icons/menu/benefits-nav-selected.svg';
import { ReactComponent as YaongconSelectedIcon } from '../assets/icons/menu/yaongcon-nav-selected.svg';
import { ReactComponent as YaongeggSelectedIcon } from '../assets/icons/menu/yaongegg-nav-selected.svg';
import { ReactComponent as MySelectedIcon } from '../assets/icons/menu/my-nav-selected.svg';
import Tory from '../assets/images/button_tory.png';
import NPayIcon from '../assets/icons/badge_npay.svg';
import YaCoinIcon from '../assets/images/img_point.png';
import ChocoCookieIcon from '../assets/icons/choco_cookie.png';
import { useLocation, useNavigate } from 'react-router';
import { useContext, useEffect, useRef, useState } from 'react';
import useSWR from 'swr';
import { AuthContext } from '../context/AuthContext';
import { useRunTimeEnvironment } from '../utils/hooks';
import ReactGA from 'react-ga4';
import { useUnityGameStatus } from '../pages/game/yaong-egg/GameProviderEgg';
import { getGetMainMarkItemListUrl } from '../api/generated/time-nyang/main/main.ts';

export default function Layout(props) {
  ReactGA.initialize('G-9XE06MMCQK');
  const { API_SERVER_DOMAIN, useAccessToken, fetchWithToken } = useContext(AuthContext);
  const navigate = useNavigate();
  const location = useLocation();
  const token = useAccessToken();
  const { data: profileInfo } = useSWR(token && [`${API_SERVER_DOMAIN}/user/profile/info`, token], fetchWithToken);
  const { data: eggInfo, mutate: revalidateEggInfo } = useSWR(
    token && [`${API_SERVER_DOMAIN}/game/egg/userGameInfo`, token],
    fetchWithToken,
  );
  const { data: mainMarkInfo } = useSWR(
    token && [`${API_SERVER_DOMAIN}${getGetMainMarkItemListUrl()}`, token],
    fetchWithToken,
  );
  const RTE = useRunTimeEnvironment();
  const { isFullyReady, setShowInModal, setGameMode } = useUnityGameStatus();
  const userPoint = profileInfo?.info?.point ?? 0;
  const snackCount = eggInfo?.userEggGameInfo?.snackCount ?? 0;
  const mainMarkItems = Array.isArray(mainMarkInfo?.mainMarkItems)
    ? mainMarkInfo.mainMarkItems
        .filter((item) => Number.isFinite(item?.goodsPrice))
        .sort((a, b) => (a?.goodsPrice ?? 0) - (b?.goodsPrice ?? 0))
    : [];
  const selectedMarkTarget =
    mainMarkItems.find((item) => userPoint <= (item?.goodsPrice ?? Number.MAX_SAFE_INTEGER)) ??
    mainMarkItems[mainMarkItems.length - 1];
  const selectedMarkTargetPrice = Math.max(1, Number(selectedMarkTarget?.goodsPrice ?? 1));
  const selectedMarkTargetLabel = selectedMarkTarget?.goodsName || selectedMarkTarget?.goodsGoodsName || '';
  const markProgressPercent = Math.min(100, Math.max(0, Math.trunc((userPoint / selectedMarkTargetPrice) * 100)));
  const menu = [
    {
      name: '놀이터',
      icon: <PlaygroundIcon />,
      iconSelected: <PlaygroundSelectedIcon />,
      url: '/playground',
    },
    {
      name: '야옹혜택',
      icon: <BenefitsIcon />,
      iconSelected: <BenefitsSelectedIcon />,
      url: '/offerwall',
    },
    {
      name: '야옹콘',
      icon: <YaongconIcon />,
      iconSelected: <YaongconSelectedIcon />,
      url: '/coupons',
    },
    {
      name: '야옹에그',
      icon: <YaongeggIcon />,
      iconSelected: <YaongeggSelectedIcon />,
      action: () => {
        if (isFullyReady) {
          setGameMode('');
          setShowInModal(true);
        }
      },
    },
    {
      name: '마이',
      icon: <MyIcon />,
      iconSelected: <MySelectedIcon />,
      url: '/user',
    },
  ];

  const selected = menu.findIndex((el) => {
    if (el.url === location.pathname) return true;
    if (el.url === '/playground' && location.pathname === '/playground-v2') return true;
    return false;
  });
  const shouldShowBottomNav = selected !== -1 || location.pathname === '/pool';
  // 로그인/가입 플로우는 하단 고정 버튼을 위해 뷰포트 높이를 강제한다.
  const isAuthOnboarding =
    location.pathname === '/' ||
    location.pathname === '/login' ||
    location.pathname.startsWith('/login-v2') ||
    location.pathname === '/oauth' ||
    location.pathname === '/verification';
  const pageContainerStyle = shouldShowBottomNav
    ? { height: '100vh', paddingBottom: '120px' }
    : isAuthOnboarding
      ? { height: '100dvh', overflow: 'hidden', background: '#F0EAF7' }
      : {};
  const [floatBtnLeft, setFloatBtnLeft] = useState('70%');
  const navRef = useRef(null);
  const infoBarRef = useRef(null);
  const pageContainerRef = useRef(null);
  const prevScrollYRef = useRef(0);
  const timerRef = useRef(null);

  function updateFloatBtn() {
    let layoutWidth = document.getElementById('main-layout').offsetWidth;
    setFloatBtnLeft(`calc(50% + ${layoutWidth / 2 - 76}px)`);
  }

  useEffect(() => {
    updateFloatBtn();
    window.addEventListener('resize', () => updateFloatBtn());
    return () => {
      window.removeEventListener('resize', () => updateFloatBtn());
    };
  }, []);

  useEffect(() => {
    if (!shouldShowBottomNav) return;
    const container = pageContainerRef.current;
    if (!container) return;

    const setTransform = (hide) => {
      if (navRef.current) navRef.current.style.transform = hide ? 'translateY(100%)' : 'translateY(0)';
      if (infoBarRef.current)
        infoBarRef.current.style.transform = hide
          ? 'translateX(-50%) translateY(80px)'
          : 'translateX(-50%) translateY(0)';
    };

    const SCROLL_THRESHOLD = 8;

    const handleScroll = () => {
      const currentScrollY = container.scrollTop;
      const delta = currentScrollY - prevScrollYRef.current;

      const atTop = currentScrollY <= 0;
      const atBottom = currentScrollY + container.clientHeight >= container.scrollHeight - 4;

      if (atTop || atBottom) {
        setTransform(false);
        prevScrollYRef.current = currentScrollY;
        return;
      }

      if (Math.abs(delta) < SCROLL_THRESHOLD) return;

      setTransform(delta > 0);
      prevScrollYRef.current = currentScrollY;
    };

    container.addEventListener('scroll', handleScroll, { passive: true });
    return () => {
      container.removeEventListener('scroll', handleScroll);
    };
  }, [shouldShowBottomNav, token]);

  useEffect(() => {
    const container = pageContainerRef.current;
    if (!container) return;

    container.scrollTo({ top: 0, behavior: 'auto' });
    window.scrollTo({ top: 0, behavior: 'auto' });
    prevScrollYRef.current = 0;

    if (navRef.current) {
      navRef.current.style.transform = 'translateY(0)';
    }

    if (infoBarRef.current) {
      infoBarRef.current.style.transform = 'translateX(-50%) translateY(0)';
    }

    if (token) {
      revalidateEggInfo();
    }
  }, [location.pathname, token, revalidateEggInfo]);

  // if (pool?.result !== "ok") return;

  return (
    <main className="layout" id="main-layout">
      {token ? (
        <>
          <div className="page-container" style={pageContainerStyle} ref={pageContainerRef}>
            {props.children}
          </div>
          {shouldShowBottomNav && (
            <div
              ref={infoBarRef}
              className="fixed bottom-[80px] left-1/2 z-[99] w-full max-w-[500px] bg-transparent"
              style={{ transform: 'translateX(-50%)', transition: 'transform 0.3s ease', willChange: 'transform' }}
            >
              <div className="relative flex h-10 w-full items-center justify-between overflow-hidden rounded-t-[12px] bg-white px-5">
                <div
                  className="pointer-events-none absolute inset-0 rounded-t-[12px] border border-solid border-gray01 border-b"
                  aria-hidden="true"
                />
                <div className="flex items-center gap-2">
                  <button
                    type="button"
                    className="flex h-[14px] cursor-pointer items-center border-0 bg-transparent p-0 outline-none"
                    onClick={() => navigate('/coupons', { state: { selectedBrand: '네이버페이' } })}
                    aria-label="네이버페이 상품 보기"
                  >
                    <img src={NPayIcon} alt="n_pay" className="block h-[14px] w-[37px] object-contain" />
                  </button>
                  <span className="text-xs font-bold text-black">
                    <span>{selectedMarkTargetLabel} </span>
                    <span className="text-primary-purple-01">{markProgressPercent}%</span>
                    <span> 달성</span>
                  </span>
                </div>
                <div className="flex items-center gap-2.5">
                  <button
                    type="button"
                    className="flex cursor-pointer items-center gap-1 border-0 bg-transparent p-0 text-sm font-bold text-black outline-none"
                    onClick={() => navigate('/user/points')}
                    aria-label="내 포인트 보기"
                  >
                    <img src={YaCoinIcon} alt="point_icon" className="h-5 w-5 object-contain" />
                    <span>{userPoint.toLocaleString()}</span>
                  </button>
                  <div className="flex items-center gap-1 text-sm font-bold text-black">
                    <img src={ChocoCookieIcon} alt="choco_cookie" className="h-4 w-4 object-contain" />
                    <span>{snackCount.toLocaleString()}</span>
                  </div>
                </div>
              </div>
            </div>
          )}
          {shouldShowBottomNav && (
            <>
              <nav className="nav-menu" ref={navRef}>
                {menu.map((menuItem, idx) => (
                  <button
                    key={'nav-' + idx}
                    type="button"
                    className={selected === idx ? 'selected-page nav-icon-selected-page' : ''}
                    onClick={() => {
                      if (menuItem.action) {
                        menuItem.action();
                        return;
                      }
                      if (menuItem.name === '야옹혜택') {
                        if (RTE === 'APP') {
                          window.flutter_inappwebview.callHandler('goto_offerwall_main');
                        } else {
                          alert('앱에서만 사용 가능해요.');
                        }
                      } else if (menuItem.name === '야옹콘') {
                        // alert('야옹콘 이용이 일시 중단되었습니다. 빠른 시일 내에 다시 찾아뵙겠습니다.');
                        navigate(menuItem.url);
                      } else {
                        navigate(menuItem.url);
                      }
                    }}
                  >
                    {selected === idx ? menuItem.iconSelected : menuItem.icon}
                    <span className="self-stretch text-center justify-center text-gray03 text-xs font-semibold font-['Pretendard']">
                      {menuItem.name}
                    </span>
                  </button>
                ))}
              </nav>
              {RTE === 'APP' && selected === 1 && (
                <img
                  src={Tory}
                  alt="tory_btn"
                  style={{ left: floatBtnLeft }}
                  onClick={() => navigate('/tory-game')}
                  className="tory-float-btn"
                />
              )}
            </>
          )}
        </>
      ) : (
        <>{props.children}</>
      )}
    </main>
  );
}
